import React from 'react';
import Icon from '../../../components/AppIcon';

const FitnessStats = ({ stats }) => {
  const statCards = [
    {
      label: 'Check-ins',
      value: stats?.checkIns,
      unit: 'this month',
      icon: 'UserCheck',
      color: 'primary',
      trend: stats?.checkInTrend
    },
    {
      label: 'Active Days',
      value: stats?.activeDays,
      unit: 'this week',
      icon: 'Calendar',
      color: 'success',
      trend: stats?.activeDaysTrend
    },
    {
      label: 'Avg Heart Rate',
      value: stats?.avgHeartRate,
      unit: 'bpm',
      icon: 'Heart',
      color: 'error',
      trend: stats?.heartRateTrend
    },
    {
      label: 'Personal Records',
      value: stats?.personalRecords,
      unit: 'total',
      icon: 'Award',
      color: 'accent',
      trend: stats?.prTrend
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      primary: 'bg-primary/10 text-primary',
      success: 'bg-success/10 text-success',
      error: 'bg-error/10 text-error',
      accent: 'bg-accent/10 text-accent'
    };
    return colorMap?.[color] || colorMap?.primary;
  };

  const getTrendIcon = (trend) => {
    if (trend > 0) return 'TrendingUp';
    if (trend < 0) return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = (trend) => {
    if (trend > 0) return 'var(--color-success)';
    if (trend < 0) return 'var(--color-error)';
    return 'var(--color-muted-foreground)';
  };

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Activity" size={20} color="var(--color-primary)" />
        </div>
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
          Fitness Stats
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {statCards?.map((stat, index) => (
          <div
            key={index}
            className="p-5 rounded-lg border border-border hover:border-primary/50 hover:shadow-md transition-all duration-250"
          >
            <div className="flex items-start justify-between mb-3">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getColorClasses(stat?.color)}`}>
                <Icon name={stat?.icon} size={24} />
              </div>
              <div className="flex items-center gap-1">
                <Icon 
                  name={getTrendIcon(stat?.trend)} 
                  size={16} 
                  color={getTrendColor(stat?.trend)}
                />
                <span 
                  className="text-xs font-medium"
                  style={{ color: getTrendColor(stat?.trend) }}
                >
                  {Math.abs(stat?.trend)}%
                </span>
              </div>
            </div>

            <div>
              <p className="text-3xl md:text-4xl font-heading font-bold text-foreground data-text mb-1">
                {stat?.value}
              </p>
              <p className="text-sm text-muted-foreground mb-1">
                {stat?.label}
              </p>
              <p className="text-xs text-muted-foreground">
                {stat?.unit}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 rounded-lg bg-gradient-to-r from-primary/5 to-success/5 border border-primary/20">
        <div className="flex items-center gap-3">
          <Icon name="Zap" size={20} color="var(--color-primary)" />
          <div>
            <p className="text-sm font-medium text-foreground">
              You're on fire! 🔥
            </p>
            <p className="text-xs text-muted-foreground">
              Keep up the great work. You're {stats?.streakDays} days into your current streak!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FitnessStats;